import React from 'react';
import {
  ActivityReport,
  activityReportQuery,
  CorporateAccount,
  PaginatedQuery,
  Reservation,
} from '@lib/state';
import { ShowMoreButton } from '..';
import { useMyAccounts, useObservable } from '../../utils';
import { Typography } from '@material-ui/core';
import { ActivityDisplay } from './activity-display.component';

interface Props {
  activity: ActivityReport[];
  reservations: Reservation[];
  userId: string;
  loadMore: (page?: PaginatedQuery) => void;
  showActions?: boolean;
  createForGuest: boolean;
  corporateAccounts?: Array<CorporateAccount>;
}

export const ActivityHistory: React.FC<Props> = ({
  activity,
  reservations,
  userId,
  loadMore,
  showActions,
  createForGuest,
  corporateAccounts,
}) => {
  const pagination = useObservable(activityReportQuery.pagination);

  return (
    <>
      {activity.length === 0 ? (
        <EmptyActivityList />
      ) : (
        <ActivityList
          userId={userId}
          activity={activity}
          reservations={reservations}
          showActions={showActions}
          createForGuest={createForGuest}
          corporateAccounts={corporateAccounts}
        />
      )}

      <ShowMoreButton
        isDone={pagination.isDone}
        loadMore={() => loadMore({ continuationToken: pagination.continuationToken })}
      />
    </>
  );
};

const EmptyActivityList: React.FC = () => {
  return <Typography>No past activity</Typography>;
};

const ActivityList: React.FC<{
  userId?: string;
  showActions?: boolean;
  activity: ActivityReport[];
  reservations: Reservation[];
  createForGuest: boolean;
  corporateAccounts?: Array<CorporateAccount>;
}> = ({ userId, activity, showActions, reservations, createForGuest, corporateAccounts }) => {
  const myAccounts = useMyAccounts();
  return (
    <>
      {activity.map((a, i) => (
        <ActivityDisplay
          key={i}
          activity={a}
          divider={i !== activity.length - 1}
          showGuest={a.guest?.userId !== userId}
          showActions={showActions}
          reservation={reservations.find(x => x.id === a.reservationId)}
          createForGuest={createForGuest}
          corporateAccounts={corporateAccounts ?? myAccounts}
        />
      ))}
    </>
  );
};
